/**
 * recently-viewed.js
 * 閲覧履歴をlocalStorageに保存し、/products/{handle}.js で商品情報を取得して描画する。
 *
 * 保存キー：sopwith_recently_viewed
 * 保存形式：{id, handle} のオブジェクト配列（新しいものが先頭）
 * 最大保存件数：20件
 */

(function () {
  var STORAGE_KEY = 'sopwith_recently_viewed';
  var MAX_STORE = 20;

  // -----------------------------------------------
  // localStorage ユーティリティ
  // -----------------------------------------------

  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      // 旧形式（IDのみの文字列配列）への後方互換
      if (parsed.length && typeof parsed[0] === 'string') return [];
      return parsed;
    } catch (e) {
      return [];
    }
  }

  function saveProduct(id, handle) {
    if (!id || !handle) return;
    var items = getStored();
    items = items.filter(function (v) { return String(v.id) !== String(id); });
    items.unshift({ id: String(id), handle: handle });
    if (items.length > MAX_STORE) items = items.slice(0, MAX_STORE);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      // シークレットモード等では無視
    }
  }

  // -----------------------------------------------
  // 商品ページでID・handleを保存
  // -----------------------------------------------

  function initSave() {
    var productInfo = document.querySelector('product-info[data-product-id]');
    if (!productInfo) return;
    var id = productInfo.getAttribute('data-product-id');
    // data-url="/products/handle" からhandleを取得
    var dataUrl = productInfo.getAttribute('data-url') || '';
    var handle = dataUrl.replace(/^\/products\//, '').split('?')[0];
    if (id && handle) saveProduct(id, handle);
  }

  // -----------------------------------------------
  // 価格フォーマット
  // -----------------------------------------------

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.recentlyViewedMoneyFormat) {
      return Shopify.formatMoney(cents, window.recentlyViewedMoneyFormat);
    }
    return '&yen;' + Math.floor(cents / 100).toLocaleString();
  }

  // -----------------------------------------------
  // カードHTML生成
  // -----------------------------------------------

  function buildCardHTML(product) {
    var imgTag = '';
    if (product.featured_image) {
      var imgUrl = product.featured_image.replace(/(\.[^.?]+)(\?.*)?$/, '_540x$1');
      imgTag = [
        '<div class="card__media">',
        '<div class="media media--transparent media--hover-effect">',
        '<img',
        '  src="' + imgUrl + '"',
        '  alt="' + (product.title || '').replace(/"/g, '&quot;') + '"',
        '  width="540"',
        '  height="540"',
        '  loading="lazy"',
        '  class="motion-reduce"',
        '>',
        '</div>',
        '</div>'
      ].join('');
    }

    // バッジ
    var badgeHTML = '';
    if (!product.available) {
      badgeHTML = '<div class="card__badge bottom left"><span class="badge badge--bottom-left color-scheme-1">Sold out</span></div>';
    } else if (product.compare_at_price && product.compare_at_price > product.price) {
      badgeHTML = '<div class="card__badge bottom left"><span class="badge badge--bottom-left color-' +
        (window.recentlyViewedSaleBadgeColorScheme || 'scheme-2') +
        '">SALE</span></div>';
    }

    // 価格
    var priceHTML;
    if (product.compare_at_price && product.compare_at_price > product.price && product.available) {
      priceHTML =
        '<span class="price-item price-item--sale">' + formatMoney(product.price) + '</span>' +
        '&nbsp;<s class="price-item price-item--regular">' + formatMoney(product.compare_at_price) + '</s>';
    } else {
      priceHTML = '<span class="price-item price-item--regular">' + formatMoney(product.price) + '</span>';
    }

    var productUrl = '/products/' + product.handle;

    return [
      '<div class="card-wrapper product-card-wrapper underline-links-hover">',
      '  <div class="card card--standard card--media">',
      '    <div class="card__inner ratio" style="--ratio-percent: 100%;">',
      '      <a href="' + productUrl + '" class="card__media-link full-unstyled-link" tabindex="-1" aria-hidden="true">',
               imgTag,
      '      </a>',
             badgeHTML,
      '    </div>',
      '    <div class="card-information">',
      '      <div class="card-information__wrapper">',
      '        <h3 class="card__heading h5">',
      '          <a href="' + productUrl + '" class="full-unstyled-link">',
                   (product.title || ''),
      '          </a>',
      '        </h3>',
      '        <div class="price">',
      '          <div class="price__container">',
               priceHTML,
      '          </div>',
      '        </div>',
      '      </div>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('\n');
  }

  // -----------------------------------------------
  // /products/{handle}.js で商品情報を取得
  // -----------------------------------------------

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () { return null; });
  }

  // -----------------------------------------------
  // セクション描画
  // -----------------------------------------------

  function renderSections() {
    var containers = document.querySelectorAll('[data-recently-viewed-section]');
    if (!containers.length) return;

    var allItems = getStored();
    if (!allItems.length) return;

    // 現在表示中の商品は除外
    var currentProductInfo = document.querySelector('product-info[data-product-id]');
    var currentId = currentProductInfo ? currentProductInfo.getAttribute('data-product-id') : null;
    var filteredItems = currentId
      ? allItems.filter(function (item) { return item.id !== String(currentId); })
      : allItems;

    if (!filteredItems.length) return;

    containers.forEach(function (container) {
      var limit = parseInt(container.getAttribute('data-limit') || '4', 10);
      var displayItems = filteredItems.slice(0, limit);
      if (!displayItems.length) return;

      var grid = container.querySelector('.recently-viewed__grid');
      if (!grid) return;

      var promises = displayItems.map(function (item) { return fetchProduct(item.handle); });

      Promise.all(promises).then(function (products) {
        var hasProduct = false;
        products.forEach(function (product) {
          if (!product) return;
          var li = document.createElement('li');
          li.className = 'grid__item';
          li.innerHTML = buildCardHTML(product);
          grid.appendChild(li);
          hasProduct = true;
        });

        if (hasProduct) {
          container.removeAttribute('hidden');
        }
      });
    });
  }

  // -----------------------------------------------
  // 初期化
  // -----------------------------------------------

  function init() {
    initSave();
    renderSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();